import { useState } from "react";
import { Button } from "@/components/shared/ui/button";
import { ChangelogPopup } from "./ChangelogPopup";
import { History } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

export const Footer = () => {
  const { t } = useTranslation();
  const { profile } = useAuth();
  const [showChangelog, setShowChangelog] = useState(false);

  return (
    <>
      <footer className="border-t bg-background mt-auto pb-safe-bottom">
        <div className="container mx-auto px-safe sm:px-6 py-4">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-0 text-sm text-muted-foreground">
            <div className="flex items-center gap-2 sm:gap-4">
              <span>© 2025 HealJou</span>
              {profile?.role === "therapist" && (
                <Button
                  variant="ghost"
                  size="sm"
                  onClick={() => setShowChangelog(true)}
                  className="h-auto p-1 text-xs min-touch-target"
                >
                  <History className="h-3 w-3 mr-1" />
                  {t("footer.changelog")}
                </Button>
              )}
            </div>

            <div className="flex items-center gap-4 min-w-0">
              <nav className="flex flex-wrap items-center gap-3">
                <Link
                  to="/betingelser"
                  className="text-sm text-muted-foreground hover:underline"
                >
                  {t("footer.terms", "Betingelser")}
                </Link>
                <Link
                  to="/privatlivspolitik"
                  className="text-sm text-muted-foreground hover:underline"
                >
                  {t("footer.privacy", "Privatlivspolitik")}
                </Link>
              </nav>

              <span className="text-xs">
                Version: {import.meta.env.VITE_APP_VERSION ?? "dev"}
              </span>
            </div>
          </div>
        </div>
      </footer>

      {profile?.role === "therapist" && (
        <ChangelogPopup open={showChangelog} onOpenChange={setShowChangelog} />
      )}
    </>
  );
};
